import GlobalCSS from './styles';

function GlobalStyles() {
  const globalStyles = GlobalCSS;
  return <style>{globalStyles}</style>;
}

export default GlobalStyles;
